/**
 * IntegrationManagementPage - Integration management
 *
 * Surfaces the IntegrationManager from @ferp/workflow-forms for admin/architect users.
 * Provides full CRUD management of external system integrations.
 *
 * Route: /admin/integration-management
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconPlugConnected } from '@tabler/icons-react';

import { IntegrationManager } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function IntegrationManagementPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="blue">
            <IconPlugConnected size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Integration Management</Title>
            <Text size="sm" c="dimmed">
              Manage external system integrations, APIs, and webhooks
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <IntegrationManager tenant={tenant?.id ?? ''} />
    </Container>
  );
}

export default IntegrationManagementPage;
